import { Box, Text, Flex, Image, Grid, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import vTopImage from '../../../assets/vTopImage.png';
import circle from '../../../assets/circle.png';
import vPass from '../../../assets/vPass.png';
import vImage from '../../../assets/vImage.png';
import { DashboardSection } from '../components/DashboardStyles';

export default function Index() {
    let navigate = useNavigate();

    return (
        <DashboardSection>
            <Text fontSize="xl" marginBottom="1rem" fontWeight="400" height="40px">
                Obana Varsity
            </Text>
            <Box position="relative" marginBottom="2rem">
                <Box
                    position="absolute"
                    zIndex="0"
                    display="grid"
                    gridTemplateColumns="repeat(2, 1fr)"
                    gridTemplateRows="repeat(1, 1fr)"
                    gridTemplateAreas='"emp item"'
                    color="#ffffff"
                    background="transparent"
                    placeItems="center"
                    width="100%"
                    borderRadius="5px"
                    height="208px">
                    <Box gridArea="emp"></Box>
                    <Box gridArea="item">
                        <Text opacity="0.5" fontSize="sm">
                            Become Obana Certified
                        </Text>
                        <Text fontSize="md" paddingBottom="1rem">
                            Welcome to Obana Varsity
                        </Text>
                        <Button background="transparent" border="1px solid blue">
                            <Text fontSize="sm" paddingRight="5px">
                                Begin Training
                            </Text>
                            <Image src={circle} alt="" width="20px" height="20px" />
                        </Button>
                    </Box>
                </Box>
                <Image
                    src={vTopImage}
                    alt="Varsity image"
                    width="1151px"
                    borderRadius="5px"
                    height="208px"
                    top="162px"
                    left="240px"
                />
            </Box>
            <Box margin="auto">
                <Text fontSize="xl" paddingBottom=".8rem" fontWeight="400">
                    Welcome to our Obana varsity!
                </Text>
                <Text fontSize="md" paddingBottom="2.5rem">
                    We are thrilled to have you join us in exploring all the incredible
                    opportunities and resources available here. Whether you're a prospective
                    student, a current member of our vibrant community, or simply curious about what
                    our university has to offer, we're here to guide you every step of the way.
                    You're{' '}
                    <Text fontSize="md" fontWeight="600" display="inline ">
                        3 levels
                    </Text>{' '}
                    away from becoming a certified business guru.
                </Text>
            </Box>
            <Grid
                gap={3}
                autoFlow="row dense"
                templateColumns={{
                    base: 'repeat(1, 1fr)',
                    sm: 'repeat(1, 1fr)',
                    md: 'repeat(2, 1fr)',
                    lg: 'repeat(3, 1fr)',
                }}>
                {[
                    {
                        level: 'Level One',
                        fundamentals: 'The fundamentals of selling',
                        stage: 'Beginner',
                        weeks: '3 weeks',
                        reason: 'By the end of this course, you will have gained a solid grasp of the foundational concept and skills in the subject. This knowledge will serve as a strong platform for your further learning and exploration in more advanced topics.',
                        certification: 'Certification by Obana after the level.',
                        payment: '100% free',
                        access: 'Get Access',
                    },
                    {
                        level: 'Level Two',
                        fundamentals: 'The fundamentals of selling',
                        stage: 'Intermediate',
                        weeks: '3 weeks',
                        reason: 'By the end of this course, you will have gained a solid grasp of the foundational concept and skills in the subject. This knowledge will serve as a strong platform for your further learning and exploration in more advanced topics.',
                        certification: 'Certification by Lagos Business School.',
                        payment: 'Payment Required',
                        access: 'Get Access',
                    },
                    {
                        level: 'Level Three',
                        fundamentals: 'The fundamentals of selling',
                        stage: 'Advance',
                        weeks: '3 weeks',
                        reason: 'By the end of this course, you will have gained a solid grasp of the foundational concept and skills in the subject. This knowledge will serve as a strong platform for your further learning and exploration in more advanced topics.',
                        certification: 'Certification by Lagos Business School.',
                        payment: 'Payment Required',
                        access: 'Get Access',
                    },
                ].map((item, index) => (
                    <Grid border="1px solid #d6d6d6" padding="1rem" borderRadius="10px" key={index}>
                        <Grid
                            gridTemplateColumns="1fr 2fr"
                            gridTemplateAreas='"image title" "image content"'
                            gap={3}>
                            <Image
                                src={vImage}
                                alt=""
                                paddingBottom="1rem"
                                gridArea="image"
                                borderRadius="6px"
                                height="100px"
                                width="104px"
                            />
                            <Text gridArea="title" fontSize="sm">
                                {item.level}: <br />
                                {item.fundamental}
                            </Text>
                            <Grid
                                gridArea="content"
                                templateColumns="repeat(2, 1fr)"
                                gap={3}
                                opacity="0.5"
                                marginTop="-10px">
                                <Text fontSize="sm">{item.stage}</Text>
                                <Text fontSize="sm">{item.weeks}</Text>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Text fontSize="sm" paddingBottom="1rem">
                                {item.reason}
                            </Text>
                        </Grid>
                        <Grid
                            gridTemplateColumns="10% 80% 10%"
                            templateColumns={{
                                base: '10% 80% 10%',
                                sm: '10% 80%',
                                md: '10% 80%',
                                lg: '10% 80% 10%',
                            }}>
                            <Image
                                src={vPass}
                                alt=""
                                height="28px"
                                width="28px"
                                paddingRight="3px"
                            />
                            <Text fontSize="xs" paddingTop=".3rem">
                                {item.certification}
                            </Text>
                        </Grid>
                        <Grid>
                            <Flex align="center" justify="space-between" paddingTop="1rem">
                                <Text fontSize="sm" opacity="0.5">
                                    {item.payment}
                                </Text>
                                <Button
                                    colorScheme="messenger"
                                    background="#1b3b5f"
                                    fontSize="sm"
                                    onClick={() => navigate('/dashboard/varsity/:id/modules')}>
                                    {item.access}
                                </Button>
                            </Flex>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </DashboardSection>
    );
}
